import React from "react";
import {MeasureFlowFeature} from "../../features/measure";
const MeasurePage = () => <MeasureFlowFeature />;
export default MeasurePage;